// @ts-strict-ignore
import { ExportToolArticleVO } from './export-tool-article.vo';
import { OBJRepresentationDataVO } from '@shared/vo/representation.vo';

export class ExportArticleModelDTO {

  public article: ExportToolArticleVO;
  public data: OBJRepresentationDataVO;
  public clearExistingData: boolean = false;
  public saveAsNewVersion: boolean = false;
}
